export const timelineStatusFunction = (currentGeneralStatus: number, billType: number) => {
    let statusTimelineData = DjangIO.app.bill.status.GeneralBillStatus.region_supported_items()
        .filter((status) => {
            if (billType === DjangIO.app.bill.models.BillType.nomination.value) {
                return [
                    DjangIO.app.bill.status.GeneralBillStatus.received.label,
                    DjangIO.app.bill.status.GeneralBillStatus.left_committee.label,
                    DjangIO.app.bill.status.GeneralBillStatus.confirmed.label,
                ].includes(status.label)
            } else if (billType === DjangIO.app.bill.models.BillType.eu_initiative.value) {
                return [
                    DjangIO.app.bill.status.GeneralBillStatus.eu_initiative_in_preparation.label,
                    DjangIO.app.bill.status.GeneralBillStatus.eu_initiative_commission_adoption.label,
                ].includes(status.label)
            } else {
                return ![
                    DjangIO.app.bill.status.GeneralBillStatus.unknown.label,
                    DjangIO.app.bill.status.GeneralBillStatus.eu_unknown.label,
                    DjangIO.app.bill.status.GeneralBillStatus.failed.label,
                    DjangIO.app.bill.status.GeneralBillStatus.received.label,
                    DjangIO.app.bill.status.GeneralBillStatus.left_committee.label,
                    DjangIO.app.bill.status.GeneralBillStatus.confirmed.label,
                    DjangIO.app.bill.status.GeneralBillStatus.returned.label,
                    DjangIO.app.bill.status.GeneralBillStatus.withdrawn.label,
                ].includes(status.label)
            }
        })
        .sort(DjangIO.valueSort)
    const globalMode = Userdata.isGlobalMode && Userdata.isGlobalMode() ? true : false
    if (currentGeneralStatus && globalMode) {
        const generalStatus = DjangIO.app.bill.status.GeneralBillStatus.by_value(currentGeneralStatus)
        const globalStatusEnum = DjangIO.app.bill.status.GlobalBillStatus
        const generalStatusEnum = DjangIO.app.bill.status.GeneralBillStatus
        const globalStatusMap = {
            [globalStatusEnum.introduced.value]: generalStatusEnum.global_introduced,
            [globalStatusEnum.in_progress.value]: generalStatusEnum.global_in_progress,
            [globalStatusEnum.adopted.value]: generalStatusEnum.global_adopted,
        }

        currentGeneralStatus = globalStatusMap[generalStatus.global_status].value
        statusTimelineData = [
            generalStatusEnum.global_introduced,
            generalStatusEnum.global_in_progress,
            generalStatusEnum.global_adopted,
        ]
    }

    return (
        currentGeneralStatus &&
        statusTimelineData.map((status) => ({
            label: status.short_label || status.label,
            isCompleted: currentGeneralStatus >= status.value,
            value: status.value,
        }))
    )
}

export const filterTimelineStatusForBillRegion = (
    statusTimelineData: Array<{ label: string; isCompleted: boolean; value: number }>,
    billRegionValue: number,
) => {
    if (!statusTimelineData || !statusTimelineData.length) return statusTimelineData

    const generalStatusEnum = DjangIO.app.bill.status.GeneralBillStatus

    const globalMode = Userdata.isGlobalMode && Userdata.isGlobalMode() ? true : false
    if (globalMode) return statusTimelineData

    return statusTimelineData.filter((entry) => {
        const statusEnumItem = generalStatusEnum.by_value(entry.value)
        const statusSupportedRegions: number[] | undefined = statusEnumItem && statusEnumItem.supported_regions
        if (!statusSupportedRegions || statusSupportedRegions.length === 0) return true
        return statusSupportedRegions.includes(billRegionValue)
    })
}
